import React from "react";
import CommonRow from "../common-row";
const FourteenStories2AdBigFact = props => {
  return <CommonRow {...props} />;
};

export default FourteenStories2AdBigFact;
